<template>
  <div class="main h-screen bg-[#AAABB8] flex flex-col place-content-center">
    <div class="flex place-content-center">
      <form class="w-border-r-white border-r-none lg:border-r-2  w-96 px-2 lg:pl-0 lg:pr-12" @submit.prevent="submitForm">
        <div class="hidden lg:block lg:h-12"></div>
        <div class="flex flex-col ">
          <div class="flex w-full justify-start mb-8 sm:mb-0 text-white text-4xl sm:text-[2rem] font-bold ">
            Welcome to Aerocle
          </div>
          <div class="flex w-full justify-between mt-4 mb-12 px-1.5 text-gray-200 font-bold ">
            <div>Don't have an account?</div>
            <div>
              <tracked-link :link="{ path: '/register', label: 'Register', displayLabel: false, class: 'inline'}">
                <span class="text-white underline underline-offset-2 font-bold ml-2 hover:text-[#181B4E] cursor-pointer">Register</span>
              </tracked-link>
            </div>
          </div>
        </div>

        <div class="flex flex-row w-full justify-center ">
          <div class="flex flex-row h-12 my-2 w-full">
            <div class="w-14 h-12 bg-white flex flex-row justify-evenly items-center rounded-l-md">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25274D"
                  class="w-10 h-10 p-1 bg-white">
                <path fill-rule="evenodd"
                      d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <input type="text" id="username" class="rounded-r-md  border-l-2 border-gray-300 w-10/12 px-4 focus:outline-0" placeholder="Username" v-model.trim="loginData.username"/>
          </div>
        </div>

        <div class="flex flex-row w-full justify-center">
          <div class="flex flex-row h-12 my-2 w-full">
            <div class="w-14 h-12 bg-white flex flex-row justify-evenly items-center rounded-l-md" >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25274D"
                  class="w-9 h-9 p-1 bg-white">
                <path fill-rule="evenodd"
                      d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <input type="password" id="password" class="rounded-r-md  border-l-2 border-gray-300 w-10/12 px-4 focus:outline-0" placeholder="Password" v-model.trim="loginData.password"/>
          </div>
        </div>

        <div class="flex flex-col justify-between items-center lg:pr-0">
          <div class="mt-1 mb-12 pr-1.5 w-full flex justify-end">
            <tracked-link :link="{ path: '/change-password/null', label: 'Forgot Password', displayLabel: false, class: 'inline'}">
              <span class="text-white font-bold underline underline-offset-2 hover:text-[#181B4E] cursor-pointer">Forgot password?</span>
            </tracked-link>
          </div>
          <button
            :disabled="!validForm"
            class="px-2 py-2 bg-dark-primary text-white font-bold leading-tight uppercase
              rounded 
              focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg
              transition duration-150 ease-in-out
              w-full
              "
            :class="{ 'hover:bg-[#181B4E] hover:shadow-md focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg' : validForm, 'opacity-50' : !validForm}"
            >
              Sign In
          </button>
        </div>
        <!-- <div id="login-error">
          {{ error }}
        </div> -->
        <div class="hidden lg:block lg:h-12"></div>
      </form>
      <div class="hidden lg:block lg:logo my-auto ml-8">
        <img id="img-gray-jet" src="../assets/images/gray_jet.png" alt="gray jet" class="w-96 "/>
      </div>
    </div>
  </div>
  </template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from 'vue-toast-notification';
import TrackedLink from './nav-bar-link-components/TrackedLink.vue';
import { handleRestAuthResponseError } from '@/composables/djRestAuth';


const store = useStore()
const router = useRouter()
const route = useRoute()
const $toast = useToast()

const loginData = reactive({
  username: '',
  password: ''
})

const mode = ref('login')
const isLoading = ref(false)
const error = ref(null)

const validForm = computed(() => {
  if(loginData.username && loginData.password.length >= 6) {
    return true
  }
  return false
})

async function submitForm() {
  if(validForm.value) {
    isLoading.value = true
    // console.log('submit form')
    const response = await store.dispatch('auth/getToken', loginData)
    // console.log('submit form response')
    // console.log(response)
    if(response.status == 200) {
      // console.log('go to home')
      router.replace(route.path.startsWith('/pwa') ? '/pwa' : '/')
    } else {
      const errorMessage = handleRestAuthResponseError(response)
      $toast.open({
        message: errorMessage,
        type: 'error',
        duration: 10000
      })
    }
    isLoading.value = false
  } else {
    console.log('form is invalid.')
  }
}
</script>

  <style scoped>

  div.main {
    background: #AAABB8; /* Old browsers */
    background: -moz-radial-gradient(center, ellipse cover, #AAABB8 1%, #25274D 100%); /* FF3.6+ */
    background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(1%, #AAABB8), color-stop(100%, #25274D)); /* Chrome,Safari4+ */
    background: -webkit-radial-gradient(center, ellipse cover, #AAABB8 1%, #25274D 100%); /* Chrome10+,Safari5.1+ */
    background: -o-radial-gradient(center, ellipse cover, #AAABB8 1%, #25274D 100%); /* Opera 12+ */
    background: -ms-radial-gradient(center, ellipse cover, #AAABB8 1%, #25274D 100%); /* IE10+ */
    background: radial-gradient(ellipse at center, #AAABB8 1%, #25274D 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#AAABB8', endColorstr='#25274D', GradientType=1); /* IE6-9 fallback on horizontal gradient */
    height: calc(100vh);
    width: 100%;
  }

  /*form {*/
  /*  margin: 1rem;*/
  /*  padding: 1rem;*/
  /*}*/
  
  /*label {*/
  /*  font-weight: bold;*/
  /*  margin-bottom: 0.5rem;*/
  /*  display: block;*/
  /*}*/
  
  /*input,*/
  /*textarea {*/
  /*  display: block;*/
  /*  width: 100%;*/
  /*  font: inherit;*/
  /*  border: 1px solid #ccc;*/
  /*  padding: 0.15rem;*/
  /*}*/
  
  /*input:focus,*/
  /*textarea:focus {*/
  /*  border-color: #3d008d;*/
  /*  background-color: #faf6ff;*/
  /*  outline: none;*/
  /*}*/
  </style>